module.exports = __webpack_public_path__ + "static/media/fifth_north_church1.bfa1f2e7.jpg";